import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntry from '@/pages/home/components/CategoryEntry';
import MovieCard from '@/components/feature/MovieCard';
import { allBanners, getLatest, getHot, formatHot, getCategoryName } from '@/utils/content';

export default function Home() {
  const latest = getLatest(10);
  const hot = getHot(6);

  return (
    <div className="pb-16">
      <HeroCarousel banners={allBanners} />

      <div className="max-w-[1400px] mx-auto -mt-8 md:-mt-10 relative z-10">
        <CategoryEntry />
      </div>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-12 md:mt-16">
        <div className="flex items-end justify-between gap-4 mb-5">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">最新内容推荐</h2>
            <p className="mt-1 text-sm text-foreground-600">按更新时间排序，第一时间追更中文字幕影视</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {latest.map((item) => (
            <MovieCard key={item.id} item={item} />
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-12 md:mt-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between gap-4 mb-5">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">热门内容推荐</h2>
                <p className="mt-1 text-sm text-foreground-600">播放量与热度排名前列的影视作品</p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-5">
              {hot.slice(0, 6).map((item) => (
                <MovieCard key={item.id} item={item} />
              ))}
            </div>
          </div>

          <aside className="lg:col-span-1">
            <div className="rounded-lg bg-primary-500 text-background-50 p-5 md:p-6">
              <h2 className="text-lg font-heading font-bold">热度排行榜</h2>
              <p className="mt-1 text-sm text-primary-100">大家都在看的中文字幕影视</p>
              <ol className="mt-5 space-y-1">
                {getHot(8).map((item, i) => (
                  <li key={item.id}>
                    <Link
                      to={`/detail/${item.id}`}
                      className="flex items-center gap-3 py-2.5 px-2 rounded-md hover:bg-primary-600 transition-colors cursor-pointer"
                    >
                      <span className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold shrink-0 ${i < 3 ? 'bg-accent-500 text-background-50' : 'bg-primary-700 text-primary-100'}`}>
                        {i + 1}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm font-medium truncate">{item.title}</span>
                        <span className="block text-xs text-primary-200 truncate">{getCategoryName(item.category)} · {item.year}</span>
                      </span>
                      <span className="text-xs text-primary-200 whitespace-nowrap">{formatHot(item.hot)}</span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
          </aside>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-12 md:mt-16">
        <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">18+</p>
              <p className="mt-1 text-sm text-foreground-600">演示影视资源</p>
            </div>
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">3</p>
              <p className="mt-1 text-sm text-foreground-600">影视分类频道</p>
            </div>
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">100%</p>
              <p className="mt-1 text-sm text-foreground-600">中文字幕覆盖</p>
            </div>
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">高清</p>
              <p className="mt-1 text-sm text-foreground-600">蓝光画质演示</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}